import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { DomainChooserModule } from '@galaxy/email-ui/domain-chooser';
import { TranslateModule } from '@ngx-translate/core';
import { ResendWelcomeEmailDialogComponent } from './resend-welcome-email-dialog.component';

@NgModule({
  declarations: [ResendWelcomeEmailDialogComponent],
  imports: [CommonModule, DomainChooserModule, MatDialogModule, TranslateModule, MatButtonModule],
})
export class ResendWelcomeEmailDialogModule {}
